'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _isLogin = require('@/mixins/isLogin');

var _isLogin2 = _interopRequireDefault(_isLogin);

var _nav = require('./nav.conf');

var _nav2 = _interopRequireDefault(_nav);

var _iconfont = require('@/components/iconfont');

var _iconfont2 = _interopRequireDefault(_iconfont);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mixins: [_isLogin2.default],
  data: function data() {
    return {
      navList: [],
      currentName: false,
      currentView: '',
      isShowAdmin: false
    };
  },
  created: function created() {
    // this.getListScope()
    this.navList = _nav2.default.call(this);
    this.setCurrActive = {
      // 'index': ['channelColumn']
    };
  },

  watch: {
    '$route': function $route() {
      var arr = this.$route.path.split('/');
      arr.forEach(function (item, index) {
        if (item == '') {
          arr.splice(index, 1);
        }
      });
      this.currentView = arr[0];
    }
  },
  methods: {
    // 设置非当前项路由的选中效果
    getCurrActive: function getCurrActive(item) {
      var isCustom = this.$route.query.columnID && this.$route.query.columnID == item.firstView;
      if (isCustom) {
        return true;
      }
      var speColumnID = ['bjlnkfdx'];
      var _obj = {
        'index': ['channel']
      };
      var arr = this.$route.path.split('/');
      arr.forEach(function (ele, index) {
        if (ele == '') {
          arr.splice(index, 1);
        }
      });
      return _obj[item.firstView] && _obj[item.firstView].includes(arr[0]) && !(this.$route.query.columnID && speColumnID.includes(this.$route.query.columnID));
    },

    //获取当前用户管理范围
    getListScope: function getListScope() {
      var _this = this;

      this.$ajax({
        url: 'user/listScope',
        type: 'GET',
        preventMessage: true
      }).then(function (_ref) {
        var data = _ref.data;

        if (data.code == 2000) {
          _this.isShowAdmin = true;
          _this.navList = _nav2.default.call(_this);
        }
      });
    },
    openRouter: function openRouter(router, item) {
      // 不鉴权弹窗
      // let _filterLoginPathArr = ['/']
      // if (!_filterLoginPathArr.includes(router)) {
      //   sessionStorage.gotoQueryPage = router
      //   if (!this.isLogin('login')) return
      // }
      // if (!this.isLogin('login')) return
      this.$router.push({ path: router, query: { queryCategoryCode: item.queryCategoryCode } });
    },
    openAdmin: function openAdmin() {
      window.open('./admin');
    },
    openUrl: function openUrl(item) {
      window.open(item.router);
    }
  },
  components: {
    Iconfont: _iconfont2.default
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//